import api from './api';

export interface DashboardStats {
  news: { total: number; published: number; draft: number };
  temples: { total: number; active: number };
  clergy: { total: number; active: number };
  videos: { total: number };
  documents: { total: number };
  newspapers: { total: number };
  necropolis: { total: number };
  galleries: { total: number };
  events: { total: number; published: number; draft: number };
}

export interface RecentActivity {
  id: number;
  action: string;
  entityType: string | null;
  entityId: number | null;
  user: string | null;
  timestamp: string;
}

export const dashboardService = {
  async getStats(): Promise<DashboardStats> {
    const response = await api.get<{ success: boolean; data: DashboardStats }>('/dashboard/stats');
    return response.data.data;
  },

  async getRecentActivity(limit: number = 10): Promise<RecentActivity[]> {
    const response = await api.get<{ success: boolean; data: RecentActivity[] }>('/dashboard/activity', {
      params: { limit }
    });
    return response.data.data;
  },
};

export default dashboardService;